/* Constants */
import { accountPath, accountScoreCardPath, accountDevicesPath, accountProfilePath, orderStatusPath } from '@constants/paths';

export const PROFILE_MENU_ACTIONS = { GET_STATUS: 'getStatus', SIGN_IN: 'signIn' };

export const LOGGED_IN_MENU = [
  {
    name: 'Orders',
    link: accountPath(),
  },
  {
    name: 'Home Scorecard',
    link: accountScoreCardPath(),
  },
  {
    name: 'Devices',
    link: accountDevicesPath(),
  },
  {
    name: 'My Account',
    link: accountProfilePath(),
  },
  {
    name: 'Sign Out',
  },
];

export const LOGGED_OUT_MENU = [
  { name: 'Track My Order', link: orderStatusPath() },
  { name: 'Sign In', action: PROFILE_MENU_ACTIONS.SIGN_IN },
];
